import * as actions from './my-contacts.actions';
import { Manager } from '../../../global/interfaces';

export interface State {
  loading: boolean;
  managers: Manager[];
}

export const initialState: State = {
  loading: false,
  managers: []
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.ActionTypes.LOAD_MANAGERS:
      return {
        ...state,
        loading: true
      };
    case actions.ActionTypes.LOAD_MANAGERS_SUCCESS:
      return {
        ...state,
        managers: action.payload
      };
    case actions.ActionTypes.LOAD_MANAGERS_FAILED:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}
